import { render } from "./SubscriptionsTab.vue?vue&type=template&id=d3352d0e&scoped=true"
import script from "./SubscriptionsTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTab.vue?vue&type=script&lang=js"

import "./SubscriptionsTab.vue?vue&type=style&index=0&id=d3352d0e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3352d0e"],['__file',"src/views/SubscriptionsTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3352d0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3352d0e', __exports__)) {
    api.reload('d3352d0e', __exports__)
  }
  
  module.hot.accept("./SubscriptionsTab.vue?vue&type=template&id=d3352d0e&scoped=true", () => {
    api.rerender('d3352d0e', render)
  })

}


export default __exports__